module.exports = __webpack_public_path__ + "img/13_12.54f31d5f.png";